export const getSearchTerms = (filter_by: string): string[] => {
  if (!filter_by) {
    return [];
  }

  const filters = filter_by?.split('&&').map((f) => f.trim());
  const searchTerms = filters?.filter((filter) =>
    filter.startsWith('search:=')
  );

  return (
    searchTerms?.map((term) => {
      const value = term.split(':=')[1];

      // Remove square brackets if they exist
      return value.replace(/^\[|\]$/g, '');
    }) ?? []
  );
};

export const parseFilterBy = (
  filter_by: string
): { filter: string; search: string[] } => {
  if (!filter_by) {
    return { filter: '', search: [] };
  }

  // Split the filters by && and trim whitespace
  const filters = filter_by?.split('&&').map((f) => f.trim());

  // Filter out any search:=[] filters and join the remaining ones back together
  const filteredString = filters
    .filter((filter) => !filter.startsWith('search:='))
    .join(' && ');

  return {
    filter: filteredString || '',
    search: getSearchTerms(filter_by),
  };
};
